export default {"src":"/_next/static/media/ir-map.6260853a.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};